// Match the existing Python round() rule used by Production weight validation.
export const roundMeshBarCount = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  const lower = Math.floor(value);
  if (value - lower === 0.5) return lower % 2 === 0 ? lower : lower + 1;
  return Math.round(value);
};
